import { Hero } from 'shared/layout/Hero'
import { useContentfulResourcesMapped } from 'stores/Contentful/hooks'
import { ResourceUtils } from 'services/ContentfulService/models/resource/utils'
import { RichTextArea } from 'experiences/shared/RichTextArea'
import { Aside } from './Aside'
import { InlineSvg } from 'components/patterns/icons/svg-tools/InlineSvg'
import { about } from 'experiences/about/About.css'
import { Container, Divider, Text, View } from 'reshaped/bundle'

export const About = () => {
	const pageResources = useContentfulResourcesMapped()

	return (
		<>
			<Hero>
				<Text variant={{ s: 'title-2', l: 'title-1' }} weight="bold">
					{ResourceUtils(pageResources['about.title']).getPlainTextContent()}
				</Text>
			</Hero>
			<Container width="1280px">
				<View paddingTop={10} paddingBottom={{ s: 10, l: 22.5 }}>
					<View direction={{ s: 'column', l: 'row' }} gap={{ s: 6 }}>
						<View.Item columns={{ s: 12, l: 6 }}>
							<View direction="column" gap={4} maxWidth="767px">
								<View direction="column" gap={2}>
									<Text variant={{ s: 'title-4', l: 'title-3' }} weight="bold">
										{ResourceUtils(pageResources['about.section_1']).getPlainTextContent()}
									</Text>
									<RichTextArea document={ResourceUtils(pageResources['about.section_1']).getRichContent()} />
								</View>
								<Divider />
								<View direction="row" gap={4} align="center" className={about}>
									{/* <Icon svg={ResourceUtils(pageResources['about.section_2']).getMediaContent().url} /> */}
									<InlineSvg
										src={ResourceUtils(pageResources['about.section_2']).getMediaContent().url}
										width={44}
										height={44}
									/>
									<RichTextArea document={ResourceUtils(pageResources['about.section_2']).getRichContent()} />
								</View>
								<Divider />
							</View>
						</View.Item>
						<View.Item columns={{ s: 12, l: 6 }}>
							<View direction="row" justify={{ s: 'start', l: 'end' }}>
								<Aside />
							</View>
						</View.Item>
					</View>
				</View>
			</Container>
		</>
	)
}
